import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileLines, faFilePdf } from "@fortawesome/free-solid-svg-icons";
import { CircularProgress, Backdrop } from "@mui/material";
import api from "../../../../api/api";
import dayjs from "dayjs";
import ViewDoc from "./htmls/homesleep";
import ViewMdq from "./htmls/mdq";
import ViewPhq9 from "./htmls/phq9";
import ViewAsrs from "./htmls/asrsform";
import ViewMmse from "./htmls/mmse";
import ViewStopBang from "./htmls/stopbang";

export const Form = ({
  items = [],
  onViewHtml,
  onViewPdf,
  data,
}) => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const practiseid = window.getPracticeId();
const [htmlModal,setHtmlModal]=useState(false)
const [selectedData,setSelectedData]=useState({})
  const handleHtml = async(row) =>{
try {
  setLoading(true)
  const response = await api.get(`/v1/${practiseid}/pcard/${data?.patientid}/formHistory/${row.id}`)
  if(response.status==200){
    setSelectedData(response.data||{})
    setHtmlModal(true)
  }
} catch (error) {
  console.llog(error)
}finally{
setLoading(false)
}
  }

 const handlePdf = (row) => {
  console.log(row);

  const pdfUrl = `/chimlw/pdf/questionaireforms/${row.id}_${row.form_id}.pdf`;

  window.open(pdfUrl, "_blank", "noopener,noreferrer");
};

  const fetchTable = async () => {
    try {
      setLoading(true);
      const response = await api.get(`/v1/${practiseid}/pcard/${data?.patientid}/formHistory`);
      
      const fetchedForms = response.status === 200 && Array.isArray(response.data)
        ? response.data
        : [];

      const mappedRows = fetchedForms.map((item) => ({
        id: item.id,
        name: item.form_name,
       datetime: dayjs(item.created_at).format('DD-MM-YYYY HH:mm:ss'),
        form_id:item?.form_id,
        recordid:item.id,
        code: item.json_data?.provider_name||'',
        htmlUrl: item.html_url || '#',
        pdfUrl: item.pdf_url || '#',
      }));

      setRows(mappedRows);
    } catch (error) {
      console.error("Failed to fetch form history:", error);
      setRows([]); // Fallback to empty array on error
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTable();
  }, []);

  return (
    <div className="relative mt-4">
      {/* Loading Spinner */}
      <Backdrop open={loading} sx={{ color: '#fff', zIndex: 9999 }}>
        <CircularProgress color="inherit" />
      </Backdrop>

      {/* Count pill */}
      <div className="absolute right-[5%] -top-8">
        <span className="inline-flex items-center px-3 py-1 rounded-md border border-[#E17954] text-[#E17954] bg-[#E179540F] text-sm">
          {rows.length} Forms
        </span>
      </div>

      {/* Table */}
      <div className="bg-white rounded-2xl shadow-md border border-gray-200 overflow-x-auto  max-h-[70vh] max-w-[95%]">

        <table className="min-w-full table-auto">
          <colgroup>
            <col className="w-[88px]" />
            <col />
            <col className="w-[180px]" />
            <col className="w-[240px]" />
          </colgroup>

          <thead>
            <tr className="bg-[#50869A]">
              <th className="text-left text-white px-5 py-3 text-[12px] font-medium font-font1">
                NO.
              </th>
              <th className="text-left text-white px-5 py-3 text-[12px] font-medium font-font1">
                FORM NAME
              </th>
              <th className="text-left text-white px-5 py-3 text-[12px] font-medium font-font1">
                DATE &amp; TIME
              </th>
              <th className="text-left text-white px-5 py-3 text-[12px] font-medium font-font1">
                ACTIONS
              </th>
            </tr>
          </thead>

          <tbody className="divide-y divide-gray-200 overflow-y-auto">
            {rows.map((row, i) => (
              <tr key={row.id ?? i} className="bg-white">
                <td className="px-5 py-4 align-top whitespace-nowrap">
                  <span className="text-[#9CA3AF] text-[14px] font-medium font-font1 leading-none">
                    {String(row.id || i + 1).padStart(2, "0")}
                  </span>
                </td>

                <td className="px-5 py-4 text-left align-top">
                  <div className="max-w-full">
                    <div className="text-[#111827] text-[14px] font-normal font-font1 truncate">
                      {row.name}
                    </div>
                    {row.code && (
                      <div className="text-[#6B7280] text-[14px] font-light font-font1 mt-1 truncate">
                        {row.code}
                      </div>
                    )}
                  </div>
                </td>

                <td className="px-5 py-4 align-top whitespace-nowrap text-left font-normal font-font1 text-[#4B5563] text-[14px]">
                  {row.datetime}
                </td>

                <td className="px-5 py-4 align-top whitespace-nowrap">
                  <div className="flex items-center gap-3">
                    <button
                      onClick={() => handleHtml(row)}
                      className="inline-flex items-center gap-2 px-3 py-2 rounded-md border-[1px] font-medium border-[#DBEAFE] bg-[#FFFFFF] text-[#2563EB] text-[14px] font-font1"
                    >
                      <FontAwesomeIcon icon={faFileLines} />
                      <span>View HTML</span>
                    </button>

                    <button
                      onClick={() => handlePdf(row)}
                      className="inline-flex items-center gap-2 px-3 py-2 rounded-md border-[1px] font-medium border-[#E1795433] bg-[#ffffff] text-[#E17954] text-[14px] font-font1"
                    >
                      <FontAwesomeIcon icon={faFilePdf} />
                      <span>View PDF</span>
                    </button>
                  </div>
                </td>
              </tr>
            ))}

            {rows.length === 0 && !loading && (
              <tr>
                <td colSpan="4" className="text-center py-6 text-gray-500">
                  No forms found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {selectedData?.form_name==="Home Sleep Questionnaire"?<ViewDoc data={selectedData} ismodalopen={htmlModal} setHtmlModal={setHtmlModal}/>:<></>}
       {selectedData?.form_name==="The Patient Health Questionnaire (PHQ-9)"?<ViewPhq9 data={selectedData} ismodalopen={htmlModal} setHtmlModal={setHtmlModal}/>:<></>}
       {selectedData?.form_name==="Mood Disorder Questionnaire (MDQ)"?<ViewMdq data={selectedData} ismodalopen={htmlModal} setHtmlModal={setHtmlModal}/>:<></>}
         {selectedData?.form_name==="Adult ADHD Self Report Scale (ASRS-vI.I) Symptom Checklist"?<ViewAsrs data={selectedData} ismodalopen={htmlModal} setHtmlModal={setHtmlModal}/>:<></>}
           {selectedData?.form_name==="Mini-Mental State Examination (MMSE)"?<ViewMmse data={selectedData} ismodalopen={htmlModal} setHtmlModal={setHtmlModal}/>:<></>}
         {selectedData?.form_name==="STOP-BANG Sleep Apnea Questionnaire"?<ViewStopBang data={selectedData} ismodalopen={htmlModal} setHtmlModal={setHtmlModal}/>:<></>}
    </div>
  );
};
